import script from "./Portfolio.vue?vue&type=script&setup=true&lang=ts"
export * from "./Portfolio.vue?vue&type=script&setup=true&lang=ts"

import "./Portfolio.vue?vue&type=style&index=0&id=cbd50c62&lang=less&scoped=true"

import exportComponent from "/home/runner/work/Portfolio/Portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbd50c62"]])

export default __exports__